"use strict";

angular.module("login").classy.controller({
    name: "ForgotPasswordController",
    inject: ["$scope", "$state", "authServiceFactory", "$location", "$window", "$timeout"],
    init: function() {
        this.$.form = {};
        this.$.loading = false;
        $(".index-loading-area").addClass("hidden");
    },
    sendemail: function() {
        this.$.loading = true;
        this.$.message = "";

        if (this.$.form.email.indexOf("@") === -1) {
            this.$.message = "You entered a V3 account login, please contact FAST Customer Service for assistance.";
        } else {
            return this.authServiceFactory.sendResetEmail(this.$.form).then((data) => {
                if (data.data.error) {
                    if (data.data.error === "invaliduser") {
                        this.$.message = "User does not exist.";
                    } else if (data.data.error === "multipleaccounts") {
                        this.$.message = "Multiple accounts exist for this user, "
                            + "please contact customer service to reset your password.";
                    } else {
                        this.$.message = "Unspecified error, please contact customer service.";
                    }
                    this.$.loading = false;
                } else if (data.data.success === 1) {
                    switch (data.data.emails) {
                        case 0:
                            this.$.message = "Unspecified error, please contact customer service.";
                            this.$.loading = false;
                            break;
                        case 1:
                            this.$.message = "An email will be sent to you shortly "
                                + "containing a link to reset your password.";
                            break;
                        default:
                            this.$.message = "Multiple emails will be sent to you shortly, "
                                + "each containing a link to reset your FAST passwords.";
                    }
                }
            });
        }
    }
});
